import React from 'react'
import { MenuContainer, MenuMobileFooter, MenuWrapper } from './styles'
import LogoDirecaoPNG from '../../assets/logo-direcao.png'
import LogoDirecaoWhitePNG from '../../assets/logo-direcao-white.png'
import { FiX } from 'react-icons/fi'
import SidebarItems from '../SideBarItems'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'

interface MobileSidebarProps {
  open?: boolean
  closeMenu(): void
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({ open, closeMenu }) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  window.onclick = function (event: any) {
    if (event.target.id === 'background') closeMenu()
  }

  return (
    <MenuContainer open={open} id="background">
      <MenuWrapper open={open}>
        <div>
          <div />
          <button onClick={closeMenu}>
            <FiX size={28} />
          </button>
        </div>
        <SidebarItems displaySidebar isMobile />
        <MenuMobileFooter>
          <img src={isDarkMode ? LogoDirecaoWhitePNG : LogoDirecaoPNG} alt="Direção Concursos" />
          <p>© Direção concursos 2023 • Todos os direitos reservados</p>
        </MenuMobileFooter>
      </MenuWrapper>
    </MenuContainer>
  )
}

export default MobileSidebar
